import React, { Component } from "react";
import { Form, Modal, message, Layout, Button, Row, Col, Input, Spin, Select } from "antd";
import "./index.scss";

const { Content } = Layout;

class TicketModal extends Component {
  initialState = {
    showModal: false,
    selectedRow: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedRow: {}
    });
    this.props.form.resetFields();
    this.props.handleCloseModal();
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.showModal !== nextProps.showModal) {
      this.setState({ showModal: nextProps.showModal });
    }

    if (this.props.selectedRow !== nextProps.selectedRow) {
      this.setState({ selectedRow: nextProps.selectedRow });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { selectedRow } = this.state;

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const params = {
          ...values,
        };

        if (!params.is_required) {
          params.is_required = false
        }

        if (params.status == "Active") {
          params.status = 1;
        } else if (params.status == "Inactive") {
          params.status = 0;
        }

        params.event_id = this.props.event.id;
        if (selectedRow.id) {
          params.id = selectedRow.id;
          await this.props
            .onUpdateTicket(params)
            .then((response) => {
              if (response.response.data.status === "success") {
                message.success('Successfuly updated ticket: ' + response.response.data.data.ticket_name);
                this.handleCloseModal();
              } else {
                message.error('Error occured: ' + response.response.data.message);
              }
            })
            .catch(error => {
              console.log("error", error);
            });
        } else {
          await this.props
            .onCreateTicket(params)
            .then((response) => {
              if (response.response.data.status === "success") {
                message.success('Successfuly created ticket: ' + response.response.data.data.ticket_name);
                this.handleCloseModal();
              } else {
                message.error('Error occured: ' + response.response.data.message);
              }
            })
            .catch(error => {
              console.log("error", error);
            });
        }
      } else {
        console.log("error", err);
      }
    });
  }

  render() {
    const { showModal, selectedRow } = this.state;
    const { isLoading, form: { getFieldDecorator }, } = this.props;

    return (
      <Modal
        title={selectedRow.id ? 'Update Ticket' : 'Create Ticket'}
        visible={showModal}
        onCancel={this.handleCloseModal}
        centered={true}
        footer={null}
        closable={false}
        maskClosable={false}
        width={"50%"}
      >
        <Layout className="overview-container">
          <Content className="overview-content" style={{ padding: "10px" }}>
            <Spin spinning={isLoading} key="create-event">
              <Form onSubmit={this.handleSubmit} style={{ width: "100%" }} disabled={isLoading}>
                <Row type="flex" gutter={30}>
                  <Col span={12}>
                    <Form.Item label="Ticket Name">
                      {getFieldDecorator("ticket_name", {
                        rules: [
                          {
                            required: true,
                            message: "Please enter Ticket Name",
                          },
                        ],
                        initialValue: selectedRow.id ? selectedRow.ticket_name : ""
                      })(<Input />)}
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item label="Issue Count">
                      {getFieldDecorator("issue_count", {
                        rules: [
                          {
                            required: true,
                            message: "Please enter Issue Count",
                          },
                        ],
                        initialValue: selectedRow.id ? selectedRow.issue_count : ""
                      })(<Input type={'number'} />)}
                    </Form.Item>
                  </Col>
                </Row>

                <Row type="flex" gutter={30}>
                  <Col span={12}>
                    <Form.Item label="Price">
                      {getFieldDecorator("price", {
                        rules: [
                          {
                            required: true,
                            message: "Please select Price",
                          },
                        ],
                        initialValue: selectedRow.id ? selectedRow.price : ""
                      })(<Input />)}
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item label="Type">
                      {getFieldDecorator("type", {
                        rules: [
                          {
                            required: true,
                            message: "Please select Type",
                          },
                        ],
                        initialValue: selectedRow.type ? selectedRow.type : ""
                      })(
                        <Select>
                          <Select.Option key="Private">Private</Select.Option>
                          <Select.Option key="Public">Public</Select.Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <Row type="flex" gutter={30}>
                  <Col span={12}>
                    <Form.Item label="Status">
                      {getFieldDecorator("status", {
                        rules: [
                          {
                            required: true,
                            message: "Please select Status",
                          },
                        ],
                        initialValue: selectedRow.status == 1 ? "Active" : "Inactive"
                      })(
                        <Select>
                          <Select.Option key="1">Active</Select.Option>
                          <Select.Option key="0">Inactive</Select.Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <Row type="flex" gutter={30}>
                  <Col span={24} align="right">
                    <Form.Item>
                      <Button
                        type="default"
                        disabled={isLoading}
                        loading={isLoading}
                        onClick={this.handleCloseModal}
                      >
                        Close
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={isLoading}
                        loading={isLoading}
                      >
                        Save
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Content>
        </Layout >
      </Modal>
    );
  }
}

const TicketModalComponent = Form.create({ name: "ticket-modal" })(TicketModal);

export default TicketModalComponent;
